import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import Config from '../../../config/config';
import { refreshAccessToken } from '../../Authorization/authSlice';

const serverPath = Config.serverPath;

export const quizLoad = createAsyncThunk(
    "quiz/quizLoad", async (id, thunkApi) => {
      const {dispatch} = thunkApi;
        const urlQuizData = serverPath + "/api/quizdata/";
        const urlToFetch =`${urlQuizData}${id}`
      const response = await fetch(urlToFetch, {
        method: 'GET',
        headers: {
            "Content-Type": "application/json; charset=utf-8",
            "Authorization": `Bearer ${localStorage.getItem('token')}`,
        },
       
        credentials: 'include',
        mode: 'cors',
    });




            let dataQuiz = [];

                if (response.ok) {
                  const  jsonResponse = await response.json();
                  console.log(jsonResponse);
                  const jsonResponseQuestion = await jsonResponse.questions;
                  const jsonResponseAnswer = await jsonResponse.answers;
                  const jsonResponseAnswerType2 = await jsonResponse.answersType2;
                  const jsonResponseAnswerType3 = await jsonResponse.answersType3;
                  const jsonResponseAnswerType4 = await jsonResponse.answersType4;
                  const jsonResponseQuestionsResult = await jsonResponse.questionsResult;

                  if (jsonResponseQuestion.length !== 0) {

                 
                console.log(jsonResponseQuestion);
                console.log(jsonResponseAnswer);
                console.log(jsonResponseAnswerType2);
                console.log(jsonResponseAnswerType3);
      
                const data = [];
               // const answers= [];
      
               // FORM DATA FOR ANSWER TYPE 1

               if (jsonResponseAnswer.length !== 0) {

                    jsonResponseQuestion.map(element => {
                       if (element.sort_quest === 1) {
                          element.answers = []; 
                          element.question = {};
                          element.question.text = element.text;
                        // element.question.question_id = element.id;
                          delete element.text;
                          data.push(element);
                        // element.answers = [];
                        return element;
                       }   
                    })


                        //console.log(data);
                    jsonResponseAnswer.map(element => {
                    // console.log(element);
                      return jsonResponseQuestion.map( question => {
                      // console.log(question.id);
                        //console.log(element.question_id);
          
                        if (question.id === element.question_id) {
                          question.answers.push(element);
                        } else return ;
                        return question;
                      })
          
                    })
                }
                //ADD STATUS TO QUESTIONS
                  jsonResponseQuestionsResult.map(element => {
                  console.log(element);
                  return jsonResponseQuestion.map( question => {
                    console.log(question.id);
                    console.log(element.question_id);
      
                    if ((question.id === element.question_id) /*&& element.hasOwnProperty('status')*/) {
                      question.status = element.status;
                      console.log('add status');
                    } 

                        else return;
                    return question;
                  })
      
                })
                  console.log(data);

                //FORM DATA FOR ANSWERS TYPE 2
                const dataType2 = [];


              if (jsonResponseAnswerType2.length !== 0) { 
                jsonResponseQuestion.map(item => {
                    if (item.sort_quest === 2) {

                        const element = {

                          id: item.id,
                          sort_quest: item.sort_quest, 
                          tasks: {},
                          columns: {
                            'column-1':{
                              id:'column-1',
                              taskIds:[],
                              taskRightIds:[],
                            }
                          },
                          columnOrder: ['column-1'],
                          text: item.text, 
                          question_img: item.question_img,

                        }
                       
                        
                      
                        dataType2.push(element);
                      
                      return item;
                    } 
                    //else return;
                      })
              }
              console.log(dataType2);


                jsonResponseAnswerType2.map(element => {
                 // console.log(element);
                  return dataType2.map( (question,index) => {
                   // console.log(question.id);
                    //console.log(element.question_id);
                    console.log(question.sort_quest);
                     
                      console.log('add set datatype 2');
                        const taskId = {
                            id: String(element.answer_id),
                            content: element.content,
                            answer_order: element.answer_order,
                        }
                        console.log(taskId);
                        if (question.id === element.question_id) {

                          console.log('start set datatype 2');

                            dataType2[index].tasks[element.answer_id] = taskId;
                            
                            
                            // SET RANDOM TASKS  
                            let randomIndex = Math.floor(Math.random() * (dataType2[index].columns['column-1'].taskIds.length + 1));
                            dataType2[index].columns['column-1'].taskIds.splice(randomIndex, 0, String(element.answer_id));

                            //SET RIGHT TASKS BY ORDER
                            dataType2[index].columns['column-1'].taskRightIds.splice((element.answer_order -1), 0, String(element.answer_id));
                            

                          } else return ;
                        return question;
                    
                  })
      
                })
                console.log(dataType2);

                //FORM DATA FOR ANSWERS TYPE 3
                const dataType3 = [];


              if (jsonResponseAnswerType3.length !== 0) { 
                jsonResponseQuestion.map(item => {
                    if (item.sort_quest === 3) {

                        const element = {

                          id: item.id,
                          sort_quest: item.sort_quest, 
                          tasks: {},
                          columns: {
                            'column-1':{
                              id:'column-1',
                              taskIds:[],
                              taskRightIds:[],
                            },
                            'column-2':{
                              id:'column-2',
                              taskIds:[],
                              
                            }
                          },
                          columnOrder: ['column-1', 'column-2'],
                          text: item.text, 
                          question_img: item.question_img,

                        }
                       
                        
                      
                        dataType3.push(element);
                      
                      return item;
                    } 
                    //else return;
                      })
              }
              console.log(dataType3);


                jsonResponseAnswerType3.map(element => {
                 // console.log(element);
                  return dataType3.map( (question,index) => {
                   // console.log(question.id);
                    //console.log(element.question_id);
                    console.log(question.sort_quest);
                     
                      console.log('add set datatype 3');
                        const taskId = {
                            id: String(element.answer_id),
                            content: element.content,
                        }
                        console.log(taskId);
                        if (question.id === element.question_id) {

                          console.log('start set datatype 3');

                            dataType3[index].tasks[element.answer_id] = taskId;
                            
                            //dataType3[index].columns['column-2'].taskIds.push(String(element.answer_id));

                            // SET RANDOM TASKS  
                            let randomIndex = Math.floor(Math.random() * (dataType3[index].columns['column-2'].taskIds.length + 1));
                            dataType3[index].columns['column-2'].taskIds.splice(randomIndex, 0, String(element.answer_id));

                            if (element.answer_right) {

                             dataType3[index].columns['column-1'].taskRightIds.push(String(element.answer_id));

                           
                            }

                          } else return ;
                        return question;
                    
                  })
      
                })
                console.log(dataType3);

                //FORM DATA FOR ANSWERS TYPE 4
                const dataType4 = [];
                const dataType4Source = [];

              if (jsonResponseAnswerType4.length !== 0) { 
                jsonResponseQuestion.map(item => {
                    if (item.sort_quest === 4) {

                        const element = {

                          id: item.id,
                          sort_quest: item.sort_quest, 
                          tasks: {},
                          columns: {
                            'column-1':{
                              id:'column-1',
                              taskIds:[],
                              taskRightIds:[],
                            }
                          },
                          columnOrder: ['column-1'],
                          text: item.text, 
                          question_img: item.question_img,

                        }
                       
                        
                      
                        dataType4.push(element);
                      
                      return item;
                    } 
                    //else return;
                      })
              }
              console.log(dataType4);


                jsonResponseAnswerType4.map(element => {
                 // console.log(element);
                  return dataType4.map( (question,index) => {
                   // console.log(question.id);
                    //console.log(element.question_id);
                    console.log(question.sort_quest);
                     
                      console.log('add set datatype 4');
                        const taskId = {
                            id: String(element.answer_id),
                            content: element.content_compare,
                        }
                        console.log(taskId);
                        if (question.id === element.question_id) {

                          console.log('start set datatype 4');

                            dataType4[index].tasks[element.answer_id] = taskId;
                            dataType4[index].columns['column-1'].taskRightIds.push(String(element.answer_id));

                            //dataType4[index].columns['column-1'].taskIds.push(String(element.answer_id));
                             // SET RANDOM TASKS  
                           let randomIndex = Math.floor(Math.random() * (dataType4[index].columns['column-1'].taskIds.length + 1));
                            dataType4[index].columns['column-1'].taskIds.splice(randomIndex, 0, String(element.answer_id));
                           

                          } else return ;
                        return question;
                    
                  })
      
                })
                console.log(dataType4);

                // TYPE 4 SOURCE DATA
                 if (jsonResponseAnswerType4.length !== 0) { 
                jsonResponseQuestion.map(item => {
                    if (item.sort_quest === 4) {

                        const element = {

                          id: item.id,
                          sort_quest: item.sort_quest, 
                          tasks: {},
                          columns: {
                            'column-1':{
                              id:'column-1',
                              taskIds:[],
                              
                            }
                          },
                          columnOrder: ['column-1'],
                          
                          img_source: item.img_source,

                        }

                        dataType4Source.push(element);
                      
                      return item;
                    } 
                    //else return;
                      })
              }

              console.log(dataType4Source);
                
              jsonResponseAnswerType4.map(element => {
                 // console.log(element);
                  return dataType4Source.map( (question,index) => {
                   // console.log(question.id);
                    //console.log(element.question_id);
                    console.log(question.sort_quest);
                     
                      console.log('add set datatype 4 source');
                        const taskId = {
                            id: String(element.answer_id),
                            content: element.content_source,
                        }
                        console.log(taskId);
                        if (question.id === element.question_id) {

                          console.log('start set datatype 4 source');

                            dataType4Source[index].tasks[element.answer_id] = taskId;
                            
                            dataType4Source[index].columns['column-1'].taskIds.push(String(element.answer_id));
                            // SET RANDOM TASKS  
                           // let randomIndex = Math.floor(Math.random() * (dataType4Source[index].columns['column-1'].taskIds.length + 1));
                            //dataType4Source[index].columns['column-1'].taskIds.splice(randomIndex, 0, String(element.answer_id));

                           

                          } else return ;
                        return question;
                    
                  })
      
                })
                console.log(dataType4Source);
                //console.log(dataType2[0].columns['column-1'].taskIds);
                //console.log(dataType2[0].tasks['1']);
               // console.log(typeof(dataType2[0].tasks['1'].id));

              //  console.log(data);
                dataQuiz = {
                  dataQuizQuestions: jsonResponseQuestion,
                  dataQuizForType1: data,
                  dataQuizForType2: dataType2,
                  dataQuizForType3: dataType3,
                  dataQuizForType4: dataType4,
                  dataQuizForType4Source: dataType4Source,

                };
                return dataQuiz;
                 } else {
                  console.log('empty GET quiz data');
                    return null;
                 }
            } else if (response.status === 401) {
                              
                                console.log('401 -refresh access token!');
                                try {
                                    const result = await dispatch(refreshAccessToken());
                                  //IF ACCESS AND REFRESH TOKEN BAD
                                    console.log(result.payload);
                                    if (result.payload) {
                                       // console.log('GOOD ACCESS!!!!');
                                      dispatch(quizLoad(id));
                                    } else {
                                        console.log('Bad refresh access');
                                    }
                                } catch (e) {
                                    console.log('Error');
                                };
                    
                    
                    
                            }
                    else {
                       
                      console.log('BAD GET quiz data');
                    return response.status;
            }
        
    }
);


const initialState = {
  userIdFromAuth:'',
  quizView: false,
  dataQuiz: [],
  dataQuizQuestions:[],
  dataQuizForMistakes: [],
  isFetching: false,
  error: "",
  quizId:'',
  quizName: '',

  question: '',

  counterQuestion: 0,
  counter: -1,
  counterForType2: -1,
  counterForType3: -1,
  counterForType4: -1,


  answerOptions: [],
  questionId: 1,
  answer: '',
  styleAnswer:{
    flag: false},
  selectedItem: null,
  answersCount: {
    trueAnswer: 0,
  },
  result: '',
  questionLength: 0,
  pointer:"auto",   //block checking other questions
  categoryView: false,
  troublesForQuizView: false,
  dataQuizView: false,
  inputFormForWorkMistakeView: false,
  dataQuestionsResult:[],
  questionIdForDB: null,
  mistakesOptionQuiz: false,
  //SORT QUESTIONS
  sortQuestion: null,
       //DATA FOR QUIZ TYPE 2
  initialDataForQuizType2: 
    [/*
      {
            question_id: 87,
            tasks: {
            'task-1': {id:'task-1', content:'when  it'},
            'task-2': {id:'task-2', content:'will be good ыафыафафыайукуй йаячааывфафыа !!!'},
            'task-3': {id:'task-3', content:'do that'},
            'task-4': {id:'task-4', content:'let go'},

            },
            columns: {
            'column-1':{ 
                id:'column-1', 
                titleColumn:'title col', 
                taskIds:['task-2', 'task-4','task-1','task-3'],
                taskRightIds:['task-1', 'task-2','task-3','task-4'], // TASK IDS FOR COMPARE
            },
          
            },
            
            columnOrder:['column-1'],
        },
                 {
          question_id: 88,
            tasks: {
            'task-1': {id:'task-1', content:'when  it'},
            'task-2': {id:'task-2', content:'will be good ыафыафафыайукуй йаячааывфафыа !!!'},
            'task-3': {id:'task-3', content:'do that'},
            'task-4': {id:'task-4', content:'let go'},

            },
            columns: {
            'column-1':{ 
                id:'column-1', 
                titleColumn:'title col', // dosnt used
                taskIds:['task-2', 'task-4','task-1','task-3'],
                taskRightIds:['task-1', 'task-2','task-3','task-4'], // TASK IDS FOR COMPARE
            },
          
            },
            
            columnOrder:['column-1'],
        },
      */],
  /*initialDataForQuizType3: {
            tasks: {
            'task-1': {id:'task-1', content:'111'},
            'task-2': {id:'task-2', content:'112'},
            'task-3': {id:'task-3', content:'211'},
            'task-4': {id:'task-4', content:'212'},

            },
            columns: {
            'column-1':{ 
                id:'column-1', 
                titleColumn:'drag to here', 
                taskIds:[],
                taskRightIds:['task-1', 'task-2','task-3','task-4'], // TASK IDS FOR COMPARE
            },
            'column-2':{ 
                    id:'column-2', 
                    titleColumn:'take from this place', 
                    taskIds:['task-4', 'task-2','task-3','task-1']},    

            
            },
            
            columnOrder:['column-1', 'column-2'],
        },*/
  /*initialDataForQuizType4: {
            tasks: {
            'task-1': {id:'task-1', content:'666'},
            'task-2': {id:'task-2', content:'555'},
            'task-3': {id:'task-3', content:'444'},
            'task-4': {id:'task-4', content:'777'},

            },
           
            columns: {
            'column-1':{ 
                id:'column-1', 
                titleColumn:'sort items in this box', 
                taskIds:['task-4', 'task-1','task-2','task-3'],
                taskRightIds:['task-3', 'task-2','task-1','task-4']}, // TASK IDS FOR COMPARE
           
            
            },
           
            columnOrder:['column-1'],
            
            
          
        },
  initialDataForQuizType4Source: {
            tasks: {
                'task-1': {id:'task-1', content:'Ivan 4'},
                'task-2': {id:'task-2', content:'Ivan 5'},
                'task-3': {id:'task-3', content:'Ivan 6'},
                'task-4': {id:'task-4', content:'Ivan 7'},
    
                },
                columns: {
                    'column-1':{ 
                        id:'column-1', 
                        titleColumn:'Source items', 
                        taskIds:['task-1', 'task-2','task-3','task-4']},
                        
                    },
                columnOrder:['column-1'],
        },*/
               //DATA FOR QUIZ TYPE 2 BEFORE CHANGING STATE
        initialDataForQuizType2AfterLoad: {
            tasks: {
            'task-1': {id:'task-1', content:'when  it'},
            'task-2': {id:'task-2', content:'will be good  ыафыафафыайукуй йаячааывфафыа !!!'},
            'task-3': {id:'task-3', content:'do that'},
            'task-4': {id:'task-4', content:'let go'},

            },
            columns: {
            'column-1':{ 
                id:'column-1', 
                titleColumn:'title col', 
                taskIds:['task-2', 'task-4','task-1','task-3'],
                taskRightIds:['task-1', 'task-2','task-3','task-4'], // TASK IDS FOR COMPARE
            },
          
            },
            
            columnOrder:['column-1'],
        },
        initialDataForQuizType3AfterLoad: {
            tasks: {
            'task-1': {id:'task-1', content:'111'},
            'task-2': {id:'task-2', content:'112'},
            'task-3': {id:'task-3', content:'211'},
            'task-4': {id:'task-4', content:'212'},

            },
            columns: {
            'column-1':{ 
                id:'column-1', 
                titleColumn:'drag to here', 
                taskIds:[],
                taskRightIds:['task-1', 'task-2','task-3','task-4'], // TASK IDS FOR COMPARE
            },
            'column-2':{ 
                    id:'column-2', 
                    titleColumn:'take from this place', 
                    taskIds:['task-4', 'task-2','task-3','task-1']},    

            
            },
            
            columnOrder:['column-1', 'column-2'],
        },
         initialDataForQuizType4AfterLoad: {
            tasks: {
            'task-1': {id:'task-1', content:'666'},
            'task-2': {id:'task-2', content:'555'},
            'task-3': {id:'task-3', content:'444'},
            'task-4': {id:'task-4', content:'777'},

            },
           
            columns: {
            'column-1':{ 
                id:'column-1', 
                titleColumn:'sort items in this box', 
                taskIds:['task-4', 'task-1','task-2','task-3'],
                taskRightIds:['task-3', 'task-2','task-1','task-4']}, // TASK IDS FOR COMPARE
           
            
            },
           
            columnOrder:['column-1'],
            
            
          
        },
        initialDataForQuizType4SourceAfterLoad: {
            tasks: {
                'task-1': {id:'task-1', content:'Ivan 4'},
                'task-2': {id:'task-2', content:'Ivan 5'},
                'task-3': {id:'task-3', content:'Ivan 6'},
                'task-4': {id:'task-4', content:'Ivan 7'},
    
                },
                columns: {
                    'column-1':{ 
                        id:'column-1', 
                        titleColumn:'Source items', 
                        taskIds:['task-1', 'task-2','task-3','task-4']},
                        
                    },
                columnOrder:['column-1'],
        }
 
};



 const options= {
    name: 'quiz',

    initialState: {
       userIdFromAuth:'',
        quizView: false,
        dataQuiz: [],
        dataQuizForMistakes: [],
        isFetching: false,
        error: "",
        quizId:'',
        quizName: '',
        
        question: '',
        questionImg: '',

        counterQuestion: 0,
        counter: -1,
        counterForType2: -1,
        counterForType3: -1,
        counterForType4: -1,

        answerOptions: [],
        questionId: 1, //using for next questions
        answer: '',
        styleAnswer:{
          flag: false},
        selectedItem: null,
        answersCount: {
          trueAnswer: 0,
        },
        result: '',
        questionLength: 0,
        pointer:"auto",
        categoryView: false,
        troublesForQuizView: false,
        dataQuizView: false,
        inputFormForWorkMistakeView: false,
        dataQuestionsResult:[],
        questionIdForDB: null,  // using for set question id in DB
        mistakesOptionQuiz: false,
          //SORT QUESTIONS
        sortQuestion: null,

        //DATA FOR QUIZ TYPE 2 (state changing afer doing quiz)
        initialDataForQuizType2: [/*
          {
          question_id: 87,
            tasks: {
            'task-1': {id:'task-1', content:'when  it'},
            'task-2': {id:'task-2', content:'will be good ыафыафафыайукуй йаячааывфафыа !!!'},
            'task-3': {id:'task-3', content:'do that'},
            'task-4': {id:'task-4', content:'let go'},

            },
            columns: {
            'column-1':{ 
                id:'column-1', 
                titleColumn:'title col', // dosnt used
                taskIds:['task-2', 'task-4','task-1','task-3'],
                taskRightIds:['task-1', 'task-2','task-3','task-4'], // TASK IDS FOR COMPARE
            },
          
            },
            
            columnOrder:['column-1'],
        },
                  {
          question_id: 88,
            tasks: {
            'task-1': {id:'task-1', content:'when  it'},
            'task-2': {id:'task-2', content:'will be good ыафыафафыайукуй йаячааывфафыа !!!'},
            'task-3': {id:'task-3', content:'do that'},
            'task-4': {id:'task-4', content:'let go'},

            },
            columns: {
            'column-1':{ 
                id:'column-1', 
                titleColumn:'title col', // dosnt used
                taskIds:['task-2', 'task-4','task-1','task-3'],
                taskRightIds:['task-1', 'task-2','task-3','task-4'], // TASK IDS FOR COMPARE
            },
          
            },
            
            columnOrder:['column-1'],
        }
      */],
       /* initialDataForQuizType3: {
            tasks: {
            'task-1': {id:'task-1', content:'111'},
            'task-2': {id:'task-2', content:'112'},
            'task-3': {id:'task-3', content:'211'},
            'task-4': {id:'task-4', content:'212'},

            },
            columns: {
            'column-1':{ 
                id:'column-1', 
                titleColumn:'drag to here', 
                taskIds:[],
                taskRightIds:['task-1', 'task-2','task-3','task-4'], // TASK IDS FOR COMPARE
            },
            'column-2':{ 
                    id:'column-2', 
                    titleColumn:'take from this place', 
                    taskIds:['task-4', 'task-2','task-3','task-1']},    

            
            },
            
            columnOrder:['column-1', 'column-2'],
        },*/
        /* initialDataForQuizType4: {
            tasks: {
            'task-1': {id:'task-1', content:'666'},
            'task-2': {id:'task-2', content:'555'},
            'task-3': {id:'task-3', content:'444'},
            'task-4': {id:'task-4', content:'777'},

            },
           
            columns: {
            'column-1':{ 
                id:'column-1', 
                titleColumn:'sort items in this box', 
                taskIds:['task-4', 'task-1','task-2','task-3'],
                taskRightIds:['task-3', 'task-2','task-1','task-4']}, // TASK IDS FOR COMPARE
           
            
            },
           
            columnOrder:['column-1'],
            
            
          
        },
        initialDataForQuizType4Source: {
            tasks: {
                'task-1': {id:'task-1', content:'Ivan 4'},
                'task-2': {id:'task-2', content:'Ivan 5'},
                'task-3': {id:'task-3', content:'Ivan 6'},
                'task-4': {id:'task-4', content:'Ivan 7'},
    
                },
                columns: {
                    'column-1':{ 
                        id:'column-1', 
                        titleColumn:'Source items', 
                        taskIds:['task-1', 'task-2','task-3','task-4']},
                        
                    },
                columnOrder:['column-1'],
        },*/
        
 
    },

    reducers: {
     // quizInfo: (state, action) => {
     //   state.quizName = action.payload;
    //    console.log(action.payload);
     // }
    //  ,
        showQuiz: (state, action) => {
            return { 
                categoryView: true,
                quizView: true,
               // expanded: !state.expanded
            }
        },
        closeQuizView: state => {
          state.categoryView =  false;
          state.quizView = false;
        },
        //SHOW TROUBLES FOR QUIZ
        showTroublesForQuizView: state => {
          state.troublesForQuizView =  true;
          console.log('WORK!!!!!!!')
          //state.quizView = false;
        },

        //  RIGHT ANSWER
        userAnswerRight: (state, action) => {
            console.log(action);

        
            state.answer = action.payload.answer;
            state.answersCount = {
              trueAnswer: state.answersCount.trueAnswer + 1
            };
            state.styleAnswer = {
              flag: true
            };
            state.selectedItem = action.payload.idx;
        //    

            state.pointer = "none";
            state.dataQuestionsResult.push([state.userIdFromAuth, state.questionIdForDB,true, state.quizId]); 
        },

        // WRONG ANSWER

        userAnswerWrong: (state, action) => {
          //ONLY FOR QUEST TYPE 1
            state.selectedItem = action.payload; 
          //
            state.pointer = "none";
            state.dataQuestionsResult.push([state.userIdFromAuth, state.questionIdForDB, false, state.quizId]);  
        },


        //NEXT QUESTION
        nextQuestion: (state, action) => {
            
          if (action.payload) {
            console.log(action.payload);
            state.counterQuestion = state.counterQuestion + 1;
            state.questionId = state.questionId + 1;
            state.styleAnswer = {
                flag: false
              };
            state.selectedItem = null;

           //FOR QUESTION TYPE 1
            if (action.payload === 1) {
            
              state.counter = state.counter + 1;
              state.question = state.dataQuiz[state.counter].question.text;
              state.questionImg = state.dataQuiz[state.counter].question_img;
              state.answerOptions = state.dataQuiz[state.counter].answers;
              state.questionIdForDB = state.dataQuiz[state.counter].id;
              state.sortQuestion = state.dataQuiz[state.counter].sort_quest;
              state.answer = '';

              state.pointer = "auto";
            }
          //FOR QUESTION TYPE 2
            if (action.payload === 2) {
              state.counterForType2 = state.counterForType2 + 1;
              state.questionIdForDB = state.initialDataForQuizType2[state.counterForType2].id;
              state.question = state.initialDataForQuizType2[state.counterForType2].text;
              state.sortQuestion = state.initialDataForQuizType2[state.counterForType2].sort_quest;

            }

             //FOR QUESTION TYPE 3
            if (action.payload === 3) {
              state.counterForType3 = state.counterForType3 + 1;
              state.questionIdForDB = state.initialDataForQuizType3[state.counterForType3].id;
              state.question = state.initialDataForQuizType3[state.counterForType3].text;
              state.sortQuestion = state.initialDataForQuizType3[state.counterForType3].sort_quest;

            }

             //FOR QUESTION TYPE 4
            if (action.payload === 4) {
              state.counterForType4 = state.counterForType4 + 1;
              state.questionIdForDB = state.initialDataForQuizType4[state.counterForType4].id;
              state.question = state.initialDataForQuizType4[state.counterForType4].text;
              state.sortQuestion = state.initialDataForQuizType4[state.counterForType4].sort_quest;

            }

          }

        },
        //GET RESULT
        getResult: (state, action) => {
            state.result = action.payload;
            state.counter = -1;
            state.counterForType2 = -1;
            state.counterForType3 = -1;
            state.counterForType4 = -1;
            state.counterQuestion = 0;


        },
        // GET first INITIAL STATE
        getInitialState: state  => 
           initialState,

           //REPEAT QUIZ
        repeatQuiz: (state, action) => {
            state.quizView = true;

        const sortQuestFirst = state.dataQuizQuestions[0].sort_quest; 
        state.sortQuestion = state.dataQuizQuestions[0].sort_quest; 
        console.log(sortQuestFirst);
                                                                              //FOR TYPE 1
        if (sortQuestFirst === 1) {
            state.question = state.dataQuiz[0].question.text;
            state.questionImg = state.dataQuiz[0].question_img;
            state.answerOptions = state.dataQuiz[0].answers;
            state.counter = 0;
           // state.sortQuestion = state.dataQuiz[0].sort_quest;

           
        } else if (sortQuestFirst === 2) {                                    //FOR TYPE 2
                  state.counterForType2 = state.counterForType2 +1;
                  state.questionIdForDB = state.initialDataForQuizType2AfterLoad[0].id;

           
        } else if (sortQuestFirst === 3) {                                   // FOR TYPE 3
                  state.counterForType3 = state.counterForType3 +1;
                  state.questionIdForDB = state.initialDataForQuizType3AfterLoad[0].id;
                  console.log();

                  
        } else if (sortQuestFirst === 4) {                                    //FOR TYPE 4
                  state.counterForType4 = state.counterForType4 +1;
                  state.questionIdForDB = state.initialDataForQuizType4AfterLoad[0].id;
        }

            state.result = '';
            state.selectedItem = null;
            state.answer = '';
            state.styleAnswer = {
              flag: false
              };
              state.questionId = 1;
            state.answersCount = {
                trueAnswer: 0,
              };
            state.pointer = "auto"; 
            state.dataQuestionsResult = [];

            

            // IF WORK ON MISTAKEN
            if (state.mistakesOptionQuiz) {
              console.log('LET WORK ON MISTAKEN QUIZ!');

               state.question = state.dataQuizForMistakes[0].question.text;
               state.questionImg = state.dataQuizForMistakes[0].question_img;
               state.answerOptions = state.dataQuizForMistakes[0].answers;
            }

            //SET INITIAL BEGINING STATE FOR TYPE QUIZ
            state.initialDataForQuizType2 = state.initialDataForQuizType2AfterLoad;
            state.initialDataForQuizType3 = state.initialDataForQuizType3AfterLoad;
            state.initialDataForQuizType4 = state.initialDataForQuizType4AfterLoad;
            state.initialDataForQuizType4Source = state.initialDataForQuizType4SourceAfterLoad;


        },
        quizSetName: (state, action) => {
          state.quizName = action.payload;
        },
        quizSetId: (state, action) => {
          state.quizId = action.payload;
        },
        openDataQuizView: (state, action) => {
          state.dataQuizView = true;
        },
        closeDataQuizView: (state, action) => {
          state.dataQuizView = false;
        },
        setUserIdFromAuth: (state, action) =>
        {
          state.userIdFromAuth = action.payload;
        },
        openInputFormForWorkMistake: (state, action) => {
          state.inputFormForWorkMistakeView = true;
        },
        closeInputFormForWorkMistake: (state, action) => {
          state.inputFormForWorkMistakeView = false;
          //IF SET WORK ON MISTAKES
          if ((action.payload) && (state.dataQuizForMistakes.length !== 0)) {
            state.question = state.dataQuizForMistakes[0].question.text;
            state.answerOptions = state.dataQuizForMistakes[0].answers;
            state.questionImg = state.dataQuizForMistakes[0].question_img;
            state.questionIdForDB = state.dataQuizForMistakes[0].id;
            state.questionLength = state.dataQuizForMistakes.length;
          } else {
             state.question = state.dataQuiz[0].question.text;
            state.answerOptions = state.dataQuiz[0].answers;
            state.questionImg = state.dataQuiz[0].question_img;
            state.questionIdForDB = state.dataQuiz[0].id;
            state.questionLength = state.dataQuiz.length;
          }
        },
        setMistakesOptionQuiz: (state, action) => {
          state.mistakesOptionQuiz = action.payload;
        },
        //FOR QUIZ TYPE 2
        setNewStateForQuizType2: (state, action) => {
            state.initialDataForQuizType2[0] = action.payload; //////SET [!]
            console.log('update new state for quiz 2 type');
            //console.log(action.payload);
        },
                //FOR QUIZ TYPE 3
        setNewStateForQuizType3: (state, action) => {           
            state.initialDataForQuizType3[0] = action.payload;       //////SET [!]
            console.log('update new state for quiz 3 type');
            //console.log(action.payload);
        },
         //FOR QUIZ TYPE 4
        setNewStateForQuizType4: (state, action) => {
            state.initialDataForQuizType4[0] = action.payload;
            console.log('update new state for quiz 4 type');
            //console.log(action.payload);
        },
    
        
    },

    extraReducers(builder) {
      builder
        .addCase(quizLoad.pending, (state, action) => {
            state.isFetching = true;
            state.error = false;
        })
        .addCase(quizLoad.fulfilled, (state, action) => {
          console.log(action.payload);
            if (action.payload) {

              state.questionLength = (action.payload.dataQuizForType1.length + action.payload.dataQuizForType2.length + action.payload.dataQuizForType3.length + action.payload.dataQuizForType4.length);
              state.dataQuizQuestions = action.payload.dataQuizQuestions;
              state.sortQuestion = action.payload.dataQuizQuestions[0].sort_quest;

              // FOR DATA ANSWER TYPE 1

            state.dataQuiz = action.payload.dataQuizForType1;

              if ((action.payload.dataQuizForType1.length !== 0) && (action.payload.dataQuizQuestions[0].sort_quest === 1)) {

                state.counter = state.counter +1;
                
                console.log(action.payload.dataQuizForType1);
                
                state.question = state.dataQuiz[0].question.text;
                state.answerOptions = state.dataQuiz[0].answers;
                
                state.quizId = action.payload.dataQuizForType1[0].quiz_id;
                state.questionImg = action.payload.dataQuizForType1[0].question_img;
                state.questionIdForDB = action.payload.dataQuizForType1[0].id;
                //state.sortQuestion = action.payload.dataQuizForType1[0].sort_quest;
              
              //DATA QUESTIONS MISTAKE
                    const newdata = [];
                    action.payload.dataQuizForType1.forEach(element => {
                      if (!element.status) {
                        newdata.push(element);
                      }
                    });
                    state.dataQuizForMistakes = newdata;
              }

              // FOR DATA ANSWER TYPE 2

                state.initialDataForQuizType2 = action.payload.dataQuizForType2;
                state.initialDataForQuizType2AfterLoad = action.payload.dataQuizForType2; //FOR REPEAT QUIZ

              if ((action.payload.dataQuizForType2.length !== 0) && (action.payload.dataQuizQuestions[0].sort_quest === 2)) {
                  state.counterForType2 = state.counterForType2 +1;
                 
                 // state.sortQuestion = action.payload.dataQuizForType2[0].sort_quest;
                  state.questionIdForDB = action.payload.dataQuizForType2[0].id;
              }

              // FOR DATA ANSWER TYPE 3

                state.initialDataForQuizType3 = action.payload.dataQuizForType3;
                state.initialDataForQuizType3AfterLoad = action.payload.dataQuizForType3; //FOR REPEAT QUIZ

              if ((action.payload.dataQuizForType3.length !== 0) && (action.payload.dataQuizQuestions[0].sort_quest === 3)) {
                  state.counterForType3 = state.counterForType3 +1;
                  state.questionIdForDB = action.payload.dataQuizForType3[0].id;
              }
              // FOR DATA ANSWER TYPE 4

                state.initialDataForQuizType4 = action.payload.dataQuizForType4;
                state.initialDataForQuizType4Source = action.payload.dataQuizForType4Source;
                state.initialDataForQuizType4AfterLoad = action.payload.dataQuizForType4; //FOR REPEAT QUIZ
                state.initialDataForQuizType4SourceAfterLoad = action.payload.dataQuizForType4Source; //FOR REPEAT QUIZ

              if ((action.payload.dataQuizForType4.length !== 0) && (action.payload.dataQuizQuestions[0].sort_quest === 4)) {
                  state.counterForType4 = state.counterForType4 +1;
                  state.questionIdForDB = action.payload.dataQuizForType4[0].id;
              }






            }


              state.isFetching = true;
              state.error = false;
              state.quizView = true;
        })
        .addCase(quizLoad.rejected, (state, action) => {
                state.isFetching = false;
                state.error = action.payload;
                console.log("oh wrong!!!")
        })

        
    }
};
    export const quizSlice = createSlice(options);
    export const {showTroublesForQuizView ,quizInfo ,closeQuizView, userAnswerRight, 
      userAnswerWrong, nextQuestion, getResult, getInitialState, repeatQuiz, quizSetName, 
      quizSetId, openDataQuizView, closeDataQuizView, setUserIdFromAuth, openInputFormForWorkMistake,
    closeInputFormForWorkMistake, setMistakesOptionQuiz, 
    setNewStateForQuizType2, setNewStateForQuizType3, setNewStateForQuizType4} = quizSlice.actions;
    export default quizSlice.reducer;
    